import { render, staticRenderFns } from "./PartyTableMap.vue?vue&type=template&id=2dafe71f"
import script from "./PartyTableMap.vue?vue&type=script&lang=js"
export * from "./PartyTableMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports